import { Box, Flex, Text, Switch } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import colors from "core/resources/theme/colors";
import SelectCarteira from "../SelectCarteira";
import SelectEspecieDocumento from "../SelectEspecieDocumento";
import SelectCnab from "../SelectCnab";
import { showError } from "infra/helpers/alerta";
import { BancoCodigo } from "core/features/contas_bancarias/enums";

function FormEmissaoBoleto({
  control,
  watch,
  bancoId,
  setValue,
  banco,
  isEdit = false,
}: {
  control: any;
  watch: any;
  bancoId: any;
  setValue: any;
  banco: any;
  isEdit?: boolean;
}) {
  const emiteBoleto = watch("emiteBoleto");
  const desabilitadaAdmin = watch("desabilitadaAdmin");

  console.log('banco', banco);

  return (
    <>
      <Box
        p="16px"
        border="1px solid #ccc"
        borderRadius={8}
        borderColor={!!emiteBoleto ? colors.primary : colors.borderGray}
        marginTop={2}
        opacity={desabilitadaAdmin ? 0.5 : 1}
      >
        <Field
          shouldUnregister
          control={control}
          name="emiteBoleto"
          render={({ field }) => {
            return (
              <Flex gap="8px">
                <Switch
                  disabled={desabilitadaAdmin}
                  isChecked={!!field.value}
                  onChange={() => {
                    // Se eu for ativar e não tiver banco selecionado, mandar um alerta
                    if (!bancoId && !field.value) {
                      showError(
                        "Você precisa selecionar um banco antes de continuar!"
                      );
                      return;
                    }

                    if (bancoId && !banco.emiteBoleto) {
                      showError(
                        "Este banco não está integrado a emissão de boleto!"
                      );
                      return;
                    }

                    setValue("bancoCarteiraId", undefined);
                    setValue("bancoEspecieDocId", undefined);
                    setValue("convenio", undefined);
                    setValue("cnab", undefined);
                    setValue("codigoCliente", undefined);
                    setValue("posto", undefined);
                    setValue("range", undefined);
                    setValue("inicioSequenciaRemessa", 1);

                    field.onChange(field.value ? false : true);
                  }}
                />
                <Text>Ativar emissão de boleto diretamente com o banco</Text>
              </Flex>
            );
          }}
        />

        {emiteBoleto ? (
          <Box
            mt="12px"
            p="10px 12px"
            bg="orange.50"
            borderRadius={6}
            borderLeft="4px solid"
            borderColor="orange.400"
          >
            <Text fontSize="sm" color="orange.700">
              Quando estiver ativo a emissão diretamente com o banco, essa será a forma padrão de emissão de boleto.
            </Text>
          </Box>
        ) : null}
        {emiteBoleto ? (
          <Box mt="16px">
            <Row gutter={16}>
              <Box as={Col} sm={12} mb={4}>
                <Field
                  label="Carteira*"
                  control={control}
                  name="bancoCarteiraId"
                  render={({ field, isInvalid }) => (
                    <SelectCarteira
                      bancoId={bancoId}
                      value={field.value}
                      disabled={desabilitadaAdmin}
                      onChange={(v, item) => {
                        field.onChange(v);
                      }}
                      isInvalid={isInvalid}
                    />
                  )}
                />
              </Box>

              {banco.codigo !== BancoCodigo.SICREDI ?
                <Box as={Col} sm={6} mb={4}>
                  <Field
                    label="Convênio"
                    control={control}
                    name="convenio"
                    inputProps={{ disabled: desabilitadaAdmin }}
                  />
                </Box>
                : null}

              {[
                BancoCodigo.CAIXA,
                BancoCodigo.SICREDI,
                BancoCodigo.SANTANDER,
                BancoCodigo.BANRISUL,
              ].includes(banco.codigo) ? (
                <Box as={Col} sm={6} mb={4}>
                  <Field
                    label="Código Cliente"
                    control={control}
                    name="codigoCliente"
                    rules={{
                      required: true,
                    }}
                    inputProps={{ disabled: desabilitadaAdmin }}
                  />
                </Box>
              ) : null}
            </Row>
            <Row gutter={16}>
              <Box as={Col} sm={12} mb={4}>
                <Field
                  label="Espécie Documento*"
                  control={control}
                  name="bancoEspecieDocId"
                  render={({ field, isInvalid }) => (
                    <SelectEspecieDocumento
                      bancoId={bancoId}
                      value={field.value}
                      onChange={(v, item) => {
                        field.onChange(v);
                      }}
                      isInvalid={isInvalid}
                      disabled={desabilitadaAdmin}
                    />
                  )}
                />
              </Box>

              {banco.codigo === BancoCodigo.BB ?
                <Box as={Col} sm={8} mb={4}>
                  <Field
                    label="Variação da Carteira"
                    control={control}
                    name="variacaoCarteira"
                    inputProps={{ disabled: desabilitadaAdmin }}
                  />
                </Box> : null}
            </Row>

            <Row gutter={16}>

              {banco.codigo === BancoCodigo.SICREDI ? (
                <Box as={Col} sm={6} mb={4}>
                  <Field
                    label="Posto"
                    control={control}
                    rules={{
                      required: true,
                    }}
                    name="posto"
                    inputProps={{ disabled: desabilitadaAdmin }}
                  />
                </Box>
              ) : null}

              {banco.codigo === BancoCodigo.HSBC ? (
                <Box as={Col} sm={6} mb={4}>
                  <Field
                    label="Range"
                    control={control}
                    rules={{
                      required: true,
                    }}
                    name="range"
                    inputProps={{ disabled: desabilitadaAdmin }}
                  />
                </Box>
              ) : null}
            </Row>
            <Text as="h4" fontSize={18} fontWeight="500" my={4}>
              Remessa
            </Text>
            <Row gutter={16}>
              <Box as={Col} sm={12} mb={4}>
                <Field
                  label="CNAB"
                  control={control}
                  name="cnab"
                  render={({ field, isInvalid }) => (
                    <SelectCnab
                      value={field.value}
                      onChange={(v, item) => {
                        field.onChange(v);
                      }}
                      isInvalid={isInvalid}
                      disabled={desabilitadaAdmin}
                    />
                  )}
                />
              </Box>

              <Box as={Col} sm={12} mb={4}>
                <Field
                  label={`${!isEdit ? "Início da sequência da remessa" : "Sequência da remessa"}`}
                  control={control}
                  name="inicioSequenciaRemessa"
                  inputProps={{ disabled: desabilitadaAdmin }}
                />
              </Box>
            </Row>

            
          </Box>
        ) : null}
      </Box>
    </>
  );
}

export default FormEmissaoBoleto;
